
export default function getAbsoluteUrl(url) {
    return location.protocol + '//' + location.host + url;
}
